<!-- Форма обязательна, так как поиск на андроиде некорректно работает-->
<form class="search-form" ngNoForm data-analytics="search_form" (submit)="$event.preventDefault()">
  <div class="search-input-wrapper">
    <input
      #searchInput
      [maxlength]="maxLength"
      class="search-input"
      placeholder="Поиск"
      aria-label="search"
      type="text"
      id="searchInput"
      autocapitalize="off"
      autocomplete="off"
      autocorrect="off"
      enterkeyhint="search"
      spellcheck="false"
      [formControl]="searchInputControl"
      (focus)="onFocusSearchInput.emit(); open()"
      (keydown.enter)="onEnterSearchInput.emit(); searchInput.blur(); close()"
      (keydown.escape)="close()"
      (keydown.arrowup)="focusPreviousChild($event)"
      (keydown.arrowdown)="focusNextChild($event)"
    />

    <div class="search-control">
      <cx-icon
        class="search-control-icon"
        [type]="iconTypes.SEARCH"
        [hidden]="searchInput.value || isLoading"
      ></cx-icon>
      <sd-spinner [size]="20" [hidden]="!isLoading"></sd-spinner>
      <label
        for="searchInput"
        tabindex="0"
        aria-label="reset"
        class="search-control-reset"
        [hidden]="!searchInput.value || isLoading"
        (mousedown)="clear.emit()"
      >
        <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
      </label>
    </div>
  </div>
  <button
    sdButton
    class="search-button-search"
    size="m"
    aria-label="search"
    tabindex="0"
    [icon]="iconTypes.SEARCH"
    (click)="onEnterSearchInput.emit(); searchInput.blur(); close()"
  ></button>
  <button
    sdButton
    class="search-button-cancel"
    type="unset"
    size="m"
    attr.aria-label="close"
    tabindex="0"
    (click)="clear.emit(); close()"
  >
    Отмена
  </button>
</form>

<ng-container *ngIf="isOpened$ | async">
  <div *ngIf="results as result" class="search-results">
    <div *ngIf="isEmpty && !isLoading" class="search-results-section message-section">
      По вашему запросу ничего не найдено
    </div>

    <div *ngIf="!isEmpty && result.taps?.length && query" class="search-results-section taps-section">
      <label
        #searchResultItem
        [tabindex]="-1"
        for="searchInput"
        class="taps-section-item"
        *ngFor="let item of result.taps"
        (keydown.escape)="close()"
        (keydown.arrowup)="focusPreviousChild($event)"
        (keydown.arrowdown)="focusNextChild($event)"
        (mousedown)="onClickTapItem.emit(item)"
        (keydown.enter)="onClickTapItem.emit(item)"
      >
        {{ item.tap }}
      </label>
    </div>

    <div *ngIf="!isEmpty && result.searchHistory?.length" class="search-results-section history-section">
      <div class="history-section-header" *ngIf="!query">
        <span class="history-section-header-title">История</span>
        <button (mousedown)="$event.stopPropagation(); searchHistoryReset.emit()" class="history-section-header-reset">
          Очистить
        </button>
      </div>

      <button
        #searchResultItem
        *ngFor="let item of result.searchHistory"
        class="history-section-item"
        (keydown.escape)="close()"
        (keydown.arrowup)="focusPreviousChild($event)"
        (keydown.arrowdown)="focusNextChild($event)"
        (mousedown)="onClickHistoryItem.emit(item); close()"
        (keydown.enter)="onClickHistoryItem.emit(item); close()"
      >
        <cx-icon class="history-section-item-icon-clock" [type]="iconTypes.CLOCK"></cx-icon>
        <span class="history-section-item-label">
          {{ item.text }}
        </span>
        <cx-icon
          (mousedown)="$event.stopPropagation(); searchHistoryRemove.emit(item)"
          class="history-section-item-icon-close"
          [type]="iconTypes.CLOSE"
        ></cx-icon>
      </button>
    </div>

    <div *ngIf="!isEmpty && result.sts?.length" class="search-results-section sts-section">
      <div class="sts-section-header" *ngIf="!query">
        <span class="sts-section-header-title">Часто ищут</span>
      </div>
      <button
        #searchResultItem
        class="sts-section-item"
        *ngFor="let item of result.sts"
        (mousedown)="onClickStsItem.emit(item); close()"
        (keydown.escape)="close()"
        (keydown.arrowup)="focusPreviousChild($event)"
        (keydown.arrowdown)="focusNextChild($event)"
        (keydown.enter)="onClickStsItem.emit(item); close()"
      >
        <cx-icon class="sts-section-item-icon" [type]="iconTypes.SEARCH"></cx-icon>
        <span class="sts-section-item-name">
          {{ item.st }}
        </span>
      </button>
    </div>

    <div *ngIf="!isEmpty && result.categories?.length && query" class="search-results-section categories-section">
      <button
        #searchResultItem
        class="categories-section-item"
        *ngFor="let item of result.categories"
        (mousedown)="onClickCategoryItem.emit(item); close()"
        (keydown.escape)="close()"
        (keydown.arrowup)="focusPreviousChild($event)"
        (keydown.arrowdown)="focusNextChild($event)"
        (keydown.enter)="onClickCategoryItem.emit(item); close()"
      >
        <span class="categories-section-item-name">{{ item.name }}</span>
        <span class="categories-section-item-caption">Категория</span>
      </button>
    </div>

    <div *ngIf="!isEmpty && result.brands?.length && query" class="search-results-section brands-section">
      <button
        #searchResultItem
        class="brands-section-item"
        *ngFor="let item of result.brands"
        (mousedown)="onClickBrandItem.emit(item); close()"
        (keydown.escape)="close()"
        (keydown.arrowup)="focusPreviousChild($event)"
        (keydown.arrowdown)="focusNextChild($event)"
        (keydown.enter)="onClickBrandItem.emit(item); close()"
      >
        <span class="brands-section-item-name">{{ item.name }}</span>
        <span class="brands-section-item-caption">Бренд</span>
      </button>
    </div>
  </div>
</ng-container>
